import { getIdentifiedPlatformConfig } from '@hmhco/login-config';

/**
 * Completes an Early Access registration by creating the user via the
 * Okta Services Gateway /early-access/user-registration endpoint.
 *
 * Sample usage:
 * submitEarlyAccessRegistration({
 *   id: '27c489d5-...', orgRefId: 'ba9bb493-...', pid: '92040090',
 *   token: 'a30258ed-...', username: 'ethun.hunt.1', firstName: 'Test',
 *   lastName: 'User', email: 'teacher@example.com', password: 'YourPassword123!',
 *   associatedSchools: ['458c9492-...'], defaultSchool: '458c9492-...',
 * });
 *
 * @param {Object} params - Registration body fields
 * @returns {Promise<Object>} Parsed JSON response
 * @throws {Error} When config/header is missing or the request fails
 */
export const submitEarlyAccessRegistration = async ({ ...body }) => {
  const { oktaEarlyAccessUserRegistrationApi } = getIdentifiedPlatformConfig();

  if (!oktaEarlyAccessUserRegistrationApi) {
    throw new Error('Missing app config: oktaEarlyAccessUserRegistrationApi');
  }

  const response = await fetch(oktaEarlyAccessUserRegistrationApi, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error(
      `Failed to submit early-access registration: ${response.status} ${response.statusText}`,
    );
  }

  return response.json().catch(() => ({}));
};

export default submitEarlyAccessRegistration;
